export default "__VITE_ASSET__b01c128d__"